module.exports = __webpack_public_path__ + "static/media/float2.fa9b6c85.png";